import * as React from 'react';
export const sendSvg = React.forwardRef(function sendSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.824 0c-.135 0-.269.023-.396.069L.731 4.96a1.1 1.1 0 0 0 .022 2.08l6.154 2.052 2.052 6.154a1.1 1.1 0 0 0 2.08.023l4.893-13.698A1.177 1.177 0 0 0 14.823 0ZM13 2 2.324 5.984l4.973 1.658L13 2ZM8.358 8.703l1.658 4.973L14 3 8.358 8.703Z',
    }),
  );
});
sendSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var send = {
  category: 'icon',
  colorable: true,
  name: 'send',
  svg: sendSvg,
};
